<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <mat-table #table [dataSource]="vm.tilknytningerForValgtBruger">
      <ng-container matColumnDef="navn">
        <mat-header-cell *matHeaderCellDef>Navn</mat-header-cell>
        <mat-cell *matCellDef="let tilknytning">{{ tilknytning?.forbrugerNavn }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="adresse">
        <mat-header-cell *matHeaderCellDef>Adresse</mat-header-cell>
        <mat-cell *matCellDef="let tilknytning">{{ tilknytning?.forbrugerAdresse }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="forbrugernr">
        <mat-header-cell *matHeaderCellDef>Forbrugernr.</mat-header-cell>
        <mat-cell *matCellDef="let tilknytning">{{ tilknytning?.ejendomNr }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="forsyning">
        <mat-header-cell *matHeaderCellDef>Forsyning</mat-header-cell>
        <mat-cell *matCellDef="let tilknytning">{{ tilknytning?.forsyningIndstillinger.forsyningNavn }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="fjern">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let tilknytning">
          @if (tilknytning.kanTilknytningSlettes) {
            <button
              mat-icon-button
              (click)="sletTilknytning(tilknytning)"
              aria-label="Slet tilknyttet forbruger permanent"
              role="button"
              type="button"
              >
              <mat-icon svgIcon="mine-oplysninger-delete-forever"></mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="kolonneOverskifter"></mat-header-row>
      <mat-row *matRowDef="let row; columns: kolonneOverskifter"></mat-row>
    </mat-table>
    <br />
    <form id="tilknyttede-forbrugere" [formGroup]="vm.form" novalidate>
      <div>
        <mat-form-field>
          <mat-select placeholder="Forsyning" formControlName="forsyningId" [value]="vm.form.value.forsyningId">
            @for (forsyning of vm.forsyninger; track forsyning) {
              <mat-option [value]="forsyning.forsyningId">
                {{ forsyning.navn }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <input matInput placeholder="Brugernavn" formControlName="brugernavn" />
          @if (vm.form.controls.brugernavn.hasError('required')) {
            <mat-error> Udfyld venligst feltet. </mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <input matInput placeholder="Kodeord" formControlName="kodeord" />
          @if (vm.form.controls.kodeord.hasError('required')) {
            <mat-error> Udfyld venligst feltet. </mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <div>
          <button
            mat-raised-button
            color="primary"
            id="tilknyt"
            aria-label="Tilknyt forbruger til forsyning"
            role="button"
            type="submit"
            [disabled]="vm.form.controls.brugernavn.invalid || vm.form.controls.kodeord.invalid"
            (click)="opretTilknytning(vm.form.value.forsyningId, vm.form.value.brugernavn, vm.form.value.kodeord)"
            >
            Tilknyt forbruger
          </button>
        </div>
        <div>
          @if (errorMessage !== '') {
            <mat-error id="tilknyttede-forbrugere-error"> {{ errorMessage }} </mat-error>
          }
        </div>
      </div>
    </form>
  }
</dff-side>
